export class ValidationResponse {
    public valid = this.message == '';

    constructor(
        public entities:any = null,
        public message = '',
    ) {
    }
}

